import { Identifier } from '../common/identifier';
import { Avatar } from '../common/avatar';
import { ConnectionPermissionType } from './connection-permission-type';

export class ConnectionPermission implements Identifier, Avatar {
    public id: string;
    public type: ConnectionPermissionType;
    public name: string;
    public avatar_url: string;
    public as_manager?: boolean;
    public as_worker?: boolean;
    public shift_swap_request?: boolean;
    public shift_giveaway_request?: boolean;
    public manage_payroll?: boolean;
    public manage_timecard?: boolean;

    public canManageLocation(): boolean {
        return (
            this.type === ConnectionPermissionType.LOCATION && this.as_manager
        );
    }

    public canManageLocationAndPayroll(): boolean {
        return (
            this.type === ConnectionPermissionType.LOCATION &&
            this.as_manager &&
            this.manage_timecard
        );
    }

    public canManagePayroll(): boolean {
        return (
            this.type === ConnectionPermissionType.LOCATION &&
            this.manage_timecard
        );
    }

    public get canManageSchedule(): boolean {
        return (
            this.type === ConnectionPermissionType.SCHEDULE && this.as_manager
        );
    }

    public isLocation(): boolean {
        return this.type === ConnectionPermissionType.LOCATION;
    }
}
